

import axios from 'axios'

const API_BASE_URL = '/api'

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// Auth API
export const authAPI = {
  setAuthToken: (token) => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    } else {
      delete api.defaults.headers.common['Authorization']
    }
  },
  
  login: (email, password) => 
    api.post('/auth/login', { email, password }),
  
  getCurrentUser: () => 
    api.get('/auth/me'),
  
  changePassword: (currentPassword, newPassword) => 
    api.put('/auth/change-password', { currentPassword, newPassword }),
  
  getUsers: () => 
    api.get('/auth/users'),
  
  registerUser: (userData) => 
    api.post('/auth/register', userData),
  
  registerWriter: (userData) => 
    api.post('/auth/register-writer', userData),
  toggleUserStatus: (userId) => 
    api.put(`/auth/users/${userId}/toggle-status`),
  
}

// Content API
export const contentAPI = {
  // Hero Section
  getHeroSection: () => api.get('/hero/admin'),
  updateHeroSection: (id, data) => api.put(`/hero/${id}`, data),
  createHeroSection: (data) => api.post('/hero', data),
  uploadHeroImage: (formData) => api.post('/hero/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  // Structure Section
  getStructureSection: () => api.get('/struktur/admin'),
  updateStructureSection: (id, data) => api.put(`/struktur/${id}`, data),
  createStructureSection: (data) => api.post('/struktur', data),

  // Program Kerja
  getProgramKerja: () => api.get('/program-kerja/admin'),
  updateProgramKerja: (id, data) => api.put(`/program-kerja/${id}`, data),
  createProgramKerja: (data) => api.post('/program-kerja', data),

  // Kegiatan
  getKegiatan: () => api.get('/kegiatan/admin'),
  updateKegiatan: (id, data) => api.put(`/kegiatan/${id}`, data),
  createKegiatan: (data) => api.post('/kegiatan', data),
  uploadKegiatanImage: (formData) => api.post('/kegiatan/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  // Ekskul
  getEkskul: () => api.get('/ekskul/admin'),
  updateEkskul: (id, data) => api.put(`/ekskul/${id}`, data),
  createEkskul: (data) => api.post('/ekskul', data),
  uploadEkskulImage: (formData) => api.post('/ekskul/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  // Pendaftaran
  getPendaftaran: () => api.get('/pendaftaran/admin'),
  updatePendaftaran: (id, data) => api.put(`/pendaftaran/${id}`, data),
  createPendaftaran: (data) => api.post('/pendaftaran', data),

  // Pengumuman
  getPengumuman: () => api.get('/pengumuman/admin'),
  updatePengumuman: (id, data) => api.put(`/pengumuman/${id}`, data),
  createPengumuman: (data) => api.post('/pengumuman', data),

  // Kotak Saran
  getAdminFeedbacks: () => api.get('/kotak-saran/admin'),
  updateFeedback: (id, data) => api.put(`/kotak-saran/${id}`, data),
  deleteFeedback: (id) => api.delete(`/kotak-saran/${id}`),
  getFeedbackStats: () => api.get('/kotak-saran/stats'),

  // Mading Penulis
  getPenulisMading: () => api.get('/mading/penulis'),
  createPenulisMading: (data) => api.post('/mading/penulis', data),
  updatePenulisMading: (id, data) => api.post('/mading/penulis', { ...data, _id: id }),
  togglePublicationStatus: (itemId) => api.put(`/mading/penulis/toggle-status/${itemId}`),
  deletePenulisMadingItem: (itemId, reason) => 
    api.request({
        url: `/mading/penulis/item/${itemId}`,
        method: 'DELETE',
        data: { reason },
        timeout: 30000,
        validateStatus: function (status) {
            return status >= 200 && status < 500;
        }
    }),

  // Mading Admin
  // getAdminMading: () => api.get('/mading/admin'),
  updateAdminMading: (madingId, data) => api.put(`/mading/${madingId}`, data),
  deleteAdminMading: (id) => api.delete(`/mading/${id}`),
  recoveryMadingItem: (itemId) => api.put(`/mading/recovery/${itemId}`),
  getAllMadingAdmin: () => api.get('/mading/admin'),
  updateMadingSection: (data) => api.put('/mading/admin-section', data),
  deleteMadingItem: (itemId, reason) => 
    api.request({
      url: `/mading/item/${itemId}`,
      method: 'DELETE',
      data: { reason },
      timeout: 30000,
      validateStatus: function (status) {
        return status >= 200 && status < 500;
      }
    }),


  // Upload (penulis & admin)
  uploadMadingImage: (formData) => api.post('/mading/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  // Settings
  getNavbar: () => api.get('/navbar/admin'),
  updateNavbar: (id,data) => api.put(`/navbar/${id}`, data),
  createNavbar: (data) => api.post('/navbar', data),
  
  getFooter: () => api.get('/footer/admin'),
  updateFooter: (id,data) => api.put(`/footer/${id}`, data),
  createFooter: (data) => api.post('/footer', data),
  
  getInformasi: () => api.get('/informasi/admin'),
  updateInformasi: (id,data) => api.put(`/informasi/${id}`, data),
  createInformasi: (data) => api.post('/informasi', data),
  
  getSaran: () => api.get('/saran/admin'),
  updateSaran: (id,data) => api.put(`/saran/${id}`, data),
  createSaran: (data) => api.post('/saran', data),
}

export default api